export function getLoginUserData() {
  return {
    payload: {
      user_id: 'sha_d9571238_rs',
      email: 'dschoon@gmail.com',
      password_hash: '$2a$10$Oj7rmvnRdsJZnPBQ/1LROefpUEDot.te.L7Y2/koiTAAJVj0tqEBa',
      access_token:
        'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjoiZHNjaG9vbkBnbWFpbC5jb20iLCJpYXQiOjE1MTgzNzQ2ODcsImV4cCI6MTUyMDk2NjY4N30.bMxVD43JT7JD3_t3tp0fP471b4IaZM1TxHtIn8scLxw',
      first_name: null,
      last_name: null,
      avatar_url: null,
      phone_number: null,
      role: 'USER',
      locale: 'en_US',
      last_login_at: 1518374687646,
      created_at: 1518327862640,
      updated_at: 1518327862641,
    },
    status: 200,
    error: '',
  };
}

export function getLoginError() {
  return {
    payload: {},
    status: 500,
    error: 'Wrong password provided',
  };
}

export function getRegisterUserData() {
  return {
    payload: {
      user_id: 'sha_d9571238_rs',
      email: 'dschoon@gmail.com',
      password_hash: '$2a$10$Oj7rmvnRdsJZnPBQ/1LROefpUEDot.te.L7Y2/koiTAAJVj0tqEBa',
      access_token:
        'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjoiZHNjaG9vbkBnbWFpbC5jb20iLCJpYXQiOjE1MTgzNzQ2ODcsImV4cCI6MTUyMDk2NjY4N30.bMxVD43JT7JD3_t3tp0fP471b4IaZM1TxHtIn8scLxw',
      first_name: null,
      last_name: null,
      avatar_url: null,
      phone_number: null,
      role: 'USER',
      locale: 'en_US',
      last_login_at: 1518374687646,
      created_at: 1518327862640,
      updated_at: 1518327862641,
    },
    status: 200,
    error: '',
  };
}

export function getRegisterError() {
  return {
    payload: {},
    status: 500,
    error: 'Passwords do not match',
  };
}
